import mapFunction from './mapResources';

export default mapFunction('building_issue_states', {
    isFetching: false,
    items: []
});